export const addQueryParametersToUrl = (url: string, parameters: Record<string, unknown>): string => {
  const queryParams = Object.entries(parameters)
    .flatMap(([fieldName, value]) => {
      if (value === null || value === undefined) {
        return [];
      }
      const encodedFieldName = encodeURIComponent(fieldName);
      if (Array.isArray(value)) {
        return value
          .filter((val) => val !== null && val !== undefined)
          .map((val) => `${encodedFieldName}=${encodeURIComponent(String(val))}`);
      }
      return [`${encodedFieldName}=${encodeURIComponent(String(value))}`];
    })
    .join("&");

  if (!queryParams) {
    return url;
  }
  return `${url}${url.includes("?") ? "&" : "?"}${queryParams}`;
};
